export function scrollToPageTop() {
  if (typeof window === 'undefined') return

  const options = { top: 0, behavior: 'smooth' }
  window.scrollTo(options)
  document.querySelector('.app-global-wrapper')?.scrollTo(options)
}
